import {combineReducers} from 'redux';
import Cookies from 'universal-cookie';
import auth from './auth';
import userEntities from './userEntities';
import profile from './profile';
import messages from './messages';
import toggles from 'go/reducers/toggles';
import dynamicComponent from './dynamicComponent';
import locationSiteData from './locationSiteData';
import userSessionData from './userSessionData';
import {routerReducer} from 'react-router-redux';
import {API_AUTH_LOGOUT_SUCCESS, LOGOUT} from 'common/types';
import programAllowSubapplication from './programAllowSubapplication';
const cookies = new Cookies();

const appReducer = combineReducers({
  auth,
  messages,
  profile,
  userEntities,
  toggles,
  router: routerReducer,
  dynamicComponent,
  userSessionData,
  locationSiteData,
  programAllowSubapplication,
});

const rootReducer = (state, action) => {
  if (action.type === LOGOUT || action.type == API_AUTH_LOGOUT_SUCCESS) {
    cookies.remove('token');
    cookies.remove('isLoginGovUser');
    cookies.remove('XSRF-TOKEN-icam');
    const {router, toggles} = state;
    state = {router, toggles};
  }

  return appReducer(state, action);
};

export default rootReducer;
